import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import './App.css';
import { Container, Grid } from '@mui/material';
import ProcessingModal from './Components/ProcessingModal';
import AlertModal from './Components/AlertModal';
import CameraFrontGuideModal from './Components/CameraFrontGuideModal';
import BackNavigationGuard from './Components/BackNavigationGuard';
import router from './router';
import { useSelector } from 'react-redux';
// import {mockData} from "./shared/constants/mockData";
// import {dynamicFlow} from "./shared/constants/dynamicFlow";
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module'

function App() {
  const content = useRoutes(router);
  const responseContext: any = useSelector<any>((state) => state.processingModalReducer);
  const responseAlertContext: any = useSelector<any>((state) => state.alertModalReducer);
  const responseCameraFrontGuide: any = useSelector<any>((state) => state.cameraFrontGuideReducer);
  const TRACKING_ID = 'G-2VT632Z142'

  // https://www.npmjs.com/package/react-gtm-module
  const tagManagerArgs = {
    gtmId: 'GTM-WR75DMG9'
  }

  useEffect(() => {

    TagManager.initialize(tagManagerArgs)
    ReactGA.initialize(TRACKING_ID, {
      // @ts-ignore
      cookieDomain: 'auto',
      debug: true,
    });
  }, []);

  return (
    <>
      {/*<DemoPages/>*/}
      {/* TODO: make dynamic inputs for every single pages */}
      {/*{mockData.map((data:{name:string,type:string})=>(*/}
      {/*    <div>*/}
      {/*        {dynamicFlow?.[data.name]}*/}
      {/*    </div>*/}
      {/*))}*/}
      <BackNavigationGuard />
      <Container disableGutters style={{ maxWidth: '550px', backgroundColor: '#6a63ff1a', borderRadius: '5px' }}>
        <ProcessingModal openModal={responseContext.processingModal} processType={responseContext.processType} />
        <AlertModal
          openModal={responseAlertContext.alertModal}
          modalType={responseAlertContext.modalType}
          title={responseAlertContext.modalTitle}
          description={responseAlertContext.modalDescription}
          buttonUrl={responseAlertContext.modalButtonUrl}
        />
        {responseCameraFrontGuide.openModal ? (
          <CameraFrontGuideModal openModal={responseCameraFrontGuide.openModal} />
        ) : null}

        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          // style={{ minHeight: '50vh' }}
          spacing={0}
        >
          {content}
        </Grid>
      </Container>
    </>
  );
}

export default App;
